import { useEffect, useState, useRef } from "react";
import { PiCursorFill, PiHandGrabbingFill } from "react-icons/pi";

export default function CustomCursor() {
    const [displayPos, setDisplayPos] = useState({ x: 0, y: 0 });
    const [cursorState, setCursorState] = useState("normal");
    const [isVisible, setIsVisible] = useState(false);

    const realMouse = useRef({ x: 0, y: 0 });
    const isAnimating = useRef(false);

    useEffect(() => {
        if (window.matchMedia("(pointer: coarse)").matches) return;

        const updateCursor = (e) => {
            realMouse.current = { x: e.clientX, y: e.clientY };

            if (!isAnimating.current) {
                setDisplayPos({ x: e.clientX, y: e.clientY });

                const target = document.querySelector(".hijack-target");
                let nearTarget = false;

                if (target) {
                    const rect = target.getBoundingClientRect();
                    const dx = Math.max(rect.left - e.clientX, 0, e.clientX - rect.right);
                    const dy = Math.max(rect.top - e.clientY, 0, e.clientY - rect.bottom);
                    const distance = Math.sqrt(dx * dx + dy * dy);

                    if (distance < 150) {
                        nearTarget = true;
                    }
                }

                setIsVisible(nearTarget);

                if (nearTarget) {
                    document.body.classList.add("hide-native-cursor");
                } else {
                    document.body.classList.remove("hide-native-cursor");
                }

                if (e.target.closest(".hijack-target")) {
                    triggerKidnap();
                }
            }
        };

        window.addEventListener("mousemove", updateCursor);

        return () => {
            window.removeEventListener("mousemove", updateCursor);
            document.body.classList.remove("hide-native-cursor");
        };
    }, []);

    const triggerKidnap = () => {
        isAnimating.current = true;
        setIsVisible(true);
        setCursorState("grabbing");

        setTimeout(() => {
            const randomX = Math.floor(Math.random() * (window.innerWidth - 100)) + 50;
            const randomY = Math.floor(Math.random() * (window.innerHeight - 100)) + 50;

            setDisplayPos({ x: randomX, y: randomY });
            setCursorState("flying");

            setTimeout(() => {
                setCursorState("normal");
                setDisplayPos({ x: realMouse.current.x, y: realMouse.current.y });

                document.body.classList.remove("hide-native-cursor");

                setTimeout(() => {
                    isAnimating.current = false;
                }, 50);
            }, 600);

        }, 150);
    };

    if (window.matchMedia("(pointer: coarse)").matches) return null;

    const isHijacked = cursorState !== "normal";
    const isFlying = cursorState === "flying";

    const transitionDuration = isFlying ? "0.6s" : "0.05s";
    const transitionTiming = isFlying ? "ease-in-out" : "linear";

    const showCursor = isVisible || isHijacked;

    return (
        <div
            className="pointer-events-none fixed left-0 top-0 z-[9999]"
            style={{
                transform: `translate(${displayPos.x}px, ${displayPos.y}px)`,
                transition: `transform ${transitionDuration} ${transitionTiming}`,
                opacity: showCursor ? 1 : 0,
            }}
        >
            <div
                className={`relative transition-transform duration-300 ${isHijacked ? "scale-125" : "scale-100"
                    }`}
            >
                {isHijacked ? (
                    <PiHandGrabbingFill className="text-red-500 text-md stroke-black [paint-order:stroke] [stroke-width:16px]" />
                ) : (
                    <PiCursorFill className="text-white text-sm stroke-black [paint-order:stroke] [stroke-width:16px]" />
                )}
            </div>
        </div>
    );
}